import React, { PureComponent } from "react";
import "./Info.css";

const classes = (...args) =>
  args
    .filter(Boolean)
    .map(item => item.trim())
    .join(" ");

export default class Info extends PureComponent {
  state = {
    open: false
  };

  toggleInfo = () => {
    this.setState(state => ({
      open: !state.open
    }));
  };

  onLinkClick = event => {
    event.stopPropagation();
  };

  render() {
    return (
      <div className={classes("Info", this.state.open && "Info-isOpen")}>
        {this.state.open && (
          <div className="Info-modal" onClick={this.toggleInfo}>
            <div className="Info-info">
              <p>
                <span>
                  Princess Worship Club is a virtual experience by artist{" "}
                </span>
                <a
                  onClick={this.onLinkClick}
                  href="https://www.felinehjermind.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Feline&nbsp;Hjermind
                </a>
              </p>
              <p>Join the club!</p>
              <p className="🖤">
                Developed by{" "}
                <a
                  onClick={this.onLinkClick}
                  href="https://reaktivo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Marcel Miranda
                </a>
              </p>
            </div>
          </div>
        )}
        <div className="Info-open">
          <a onClick={this.toggleInfo}>?</a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Info/Info.js